<template>
  <v-expansion-panel v-model="panel">
    <v-expansion-panel-content
      v-for="extra in product.extras"
      :key="extra.key"
    >
      <template v-slot:header>
        <span
          :class="{'no-flex' : selections[extra.key] && selections[extra.key].length}"
          class="font-weight-bold">
          {{ extra.name }}
        </span>
        <span
          v-if="selections[extra.key] && selections[extra.key].length"
          class="font-weight-light font-italic">
          : {{ selectedOptions[extra.key].join(', ') }}
        </span>
      </template>

      <v-divider/>

      <order-draft-item-extra-selection
        v-model="selections[extra.key]"
        :extra="extra"
        class="product-extra-selector"
        @change="select"
      />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import OrderDraftItemExtraSelection from '@/modules/Orders/components/OrderDraft/Items/OrderDraftItemExtraSelection'
export default {
  name: 'OrderDraftItemExtras',
  components: { OrderDraftItemExtraSelection },
  props: {
    product: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      selections: {},
      panel: 0
    }
  },

  computed: {
    selectedOptions () {
      const options = []
      for (const key in this.selections) {
        options[key] = []
        if (!this.selections[key]) {
          continue
        }

        const extra = this.product.extras.find(e => key === e.key)
        if (!extra) {
          continue
        }

        this.selections[key].forEach(selectedOption => {
          const opt = extra.options.find(opt => opt.key === selectedOption)
          if (opt) {
            options[key].push(opt.value)
          }
        })
      }

      return options
    }
  },

  methods: {
    select () {
      if (this.selections.length === 0) {
        return
      }

      for (const key in this.selections) {
        if (this.selections[key] && this.selections[key].length === 0) {
          delete this.selections[key]
        }
      }

      this.$emit('selected', this.selections)
    }
  }
}
</script>

<style scoped>
  .no-flex {
    flex: none !important;
  }
</style>
